export enum ActionTypes {
  CHANGE_LANGUAGE = 'app/settings/CHANGE_LANGUAGE)'
}